// extracted by mini-css-extract-plugin
export default {"video":"VideoSection_video__AsNoY","section":"VideoSection_section__x0YNE","container":"VideoSection_container__iaUCI"};